<template>
    <section class="u-width-full">
        <div class="u-flex u-flex-justify-end u-flex-justify-start@s">
            <a data-cy="join-community" href="#" v-if="$root.user === false || community.isMember === false" :class="['c-btn', 'c-btn--join-community']" @click.prevent="join"><p>Join</p></a>
            <a href="#" v-else :class="['c-btn', 'c-btn--invite']" @click.prevent="invite"><p>Invite</p></a>
        </div>
        <aside :class="['c-article__menu', { 'open': showContextMenu }]" @click="toggleContextMenu">&nbsp;</aside>
        <div :class="['c-article__menu-items', { 'open': showContextMenu }]">
            <ul>
                <li v-if="community.isMember === false"><a href="#" @click.prevent="join">Join Community</a></li>
                <li v-if="community.isMember && !community.isSubscribed"><a href="#" @click.prevent="subscribeToNotifications">Enable Device Notifications</a></li>
                <li v-if="community.isMember && community.isSubscribed"><a href="#" @click.prevent="unsubscribeToNotifications">Unsubscribe Device Notifications</a></li>
                <li><a href="#" class="community-copy-link" :data-link="'/' + community.url" @click.prevent="copyUrl">Copy the URL <span v-show="copySuccess">&#9989;</span></a></li>
                <li v-if="community.isMember"><a href="#" @click.prevent="leave">Leave Community</a></li>
                <!--<li><a href="#" :class="{ 'js-join-convo__cta': this.rU === false}">Flag Content</a></li>
                <li><a href="#" :class="{ 'js-join-convo__cta': this.rU === false}">Hide User Posts</a></li>
                <li><a href="#" :class="{ 'js-join-convo__cta': this.rU === false}">Report User</a></li>-->
                <li><a href="#" @click.prevent="toggleContextMenu">Cancel</a></li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            community: this.$root.community,
            stats: this.$simpleStore.stats,
            message: this.$simpleStore.message,
            showContextMenu: false,
            copySuccess: false
        }
    },
    created() {
        this.$root.$on('menu-toggle-community', (data) => {
            this.toggleContextMenu(true);
        });
        // for user and guest invites, this.$root.invited will be set in frontend/default/controllers/CommunityController.php in viewAction method
        if (this.community.isMember === false && this.$root.invited === true) {
            this.join();
        }
    },
    methods: {
        copyUrl(event) {
            this.$simpleStore.copyLink(event);
            this.copySuccess = true;
            this.toggleContextMenu();
        },
        toggleContextMenu(clickOutside = false) {
            this.showContextMenu = this.$simpleStore.contextMenu(this, clickOutside);
        },
        showMemberPanel() {
            this.$simpleStore.showMemberPanel(this);
        },
        subscribeToNotifications() {
            let parameters = {
                userId: this.$root.user.id,
                communityId: this.community.id,
                subscriptionId: $cookies.get('subscriptionId') != null ? parseInt($cookies.get('subscriptionId')) : null
            };
            // if subscriptionId cookie not set we may need be subscribed with browser for notifications yet
            if (parameters.subscriptionId == null) {
                this.$simpleStore.subscribeToNotifications().then((subscription) => {
                    parameters.subscription = subscription;
                    this.$http.post('/api/v1/subscribe', parameters).then(response => {
                        // set subscriptionId cookie if sid returned from server
                        if (typeof response.data.sid != 'undefined') {
                            $cookies.set('subscriptionId', response.data.sid, '1y');
                        }
                        this.community.isSubscribed = true;
                    }, response => {
                        console.log('Subscription error');
                        console.log(response);
                    });
                });
            } else {
                this.$http.post('/api/v1/subscribe', parameters).then(response => {
                    this.community.isSubscribed = true;
                }, response => {
                    console.log('Subscription error');
                    console.log(response);
                });
            }
        },
        unsubscribeToNotifications() {
            let parameters = {
                userId: this.$root.user.id,
                communityId: this.community.id
            };
            // PHP code will grab subscriptionId from cookie so no need to send with parameters here
            this.$http.post('/api/v1/unsubscribe', parameters).then(response => {
                this.community.isSubscribed = false;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        invite() {
            this.$root.$emit('bus-show-invite-panel');
        },
        join() {
            this.toggleContextMenu(true);
            if (this.$root.user === false) {
                this.showMemberPanel();
                return;
            }
            this.$http.get('/join/' + this.community.id).then(response => {
                let data = response.data;
                let modalData = { cta: false };
                // user not logged in
                if (data.rU === false) {
                    modalData.title = 'You are not registered/logged in';
                    modalData.message = 'Please login or register to join a community';
                } else if (data.s === false) {
                    modalData.title = 'Already joined';
                    modalData.message = 'You have previously joined this community';
                } else {
                    modalData.title = 'Successfully joined';
                    modalData.message = 'You have successfully joined the ' + this.$root.community.name + ' community';
                    this.community.isMember = true;
                    let communityImgs = document.getElementsByClassName('c-community__img');
                    for (let i = 0; i < communityImgs.length; i++) {
                        communityImgs[i].classList.add('member');
                    }
                }
                this.$root.$emit('bus-show-community-modal', modalData);
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        like(confirmed) {
            this.$simpleStore.like(this, confirmed);
        },
        leave() {
            this.toggleContextMenu(true);
            if (this.$root.user === false) {
                this.showMemberPanel();
                return;
            }
            this.$http.get('/leave/' + this.community.id).then(response => {
                let data = response.data;
                let modalData = { cta: false };
                // user not logged in
                if (data.rU === false) {
                    modalData.title = 'You are not registered/logged in';
                    modalData.message = 'Please login or register to leave a community';
                } else if (data.s === false) {
                    modalData.title = 'Not a member';
                    modalData.message = 'You cannot leave a community you are not already a member of.';
                } else {
                    modalData.title = 'Successfully left';
                    modalData.message = 'You have successfully left the ' + this.$root.community.name + ' community';
                    this.community.isMember = false;
                    this.$simpleStore.clearMembershipCaches(this, this.community.id);
                    let communityImgs = document.getElementsByClassName('c-community__img');
                    for (let i = 0; i < communityImgs.length; i++) {
                        communityImgs[i].classList.remove('member');
                    }
                }
                this.$root.$emit('bus-show-community-modal', modalData);
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        }
    }
}
</script>
